/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingCacheImplementationException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let MissingCacheImplementationException = exports.MissingCacheImplementationException = function (_Exception) {
  _inherits(MissingCacheImplementationException, _Exception);

  function MissingCacheImplementationException() {
    _classCallCheck(this, MissingCacheImplementationException);

    return _possibleConstructorReturn(this, (MissingCacheImplementationException.__proto__ || Object.getPrototypeOf(MissingCacheImplementationException)).call(this, 'Missing cache implementation in Request object'));
  }

  return MissingCacheImplementationException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/MissingCacheImplementationException.js
// module id = 420
// module chunks = 0